import { render } from "./SidenavComponent.vue?vue&type=template&id=9009319a&scoped=true"
import script from "./SidenavComponent.vue?vue&type=script&lang=js"
export * from "./SidenavComponent.vue?vue&type=script&lang=js"

import "./SidenavComponent.vue?vue&type=style&index=0&id=9009319a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9009319a"]])

export default __exports__